import { Box, ChakraProps } from "@chakra-ui/react";
import { FC } from "react";

export const OrderedList: FC<Readonly<ChakraProps>> = ({
  children,
  ...props
}) => (
  <Box
    as="ol"
    py={0}
    px={5}
    my={6}
    sx={{
      // Remove the margins of nested lists, rely only on list item margins.
      "& li > ul, & li > ol": { my: 0 },
      "ol ul, ol ol": { my: 0 },
    }}
    {...props}
  >
    {children}
  </Box>
);

export const UnorderedList: FC<Readonly<ChakraProps>> = ({
  children,
  ...props
}) => (
  <Box
    as="ul"
    py={0}
    px={5}
    my={6}
    listStyleType="disc"
    sx={{
      // Remove the margins of nested lists, rely only on list item margins.
      "& li > ul, & li > ol": { my: 0 },
      "ul ul, ul ol": { my: 0 },
    }}
    {...props}
  >
    {children}
  </Box>
);

export const ListItem: FC<Readonly<ChakraProps>> = ({ children, ...props }) => (
  <Box as="li" my={2} {...props}>
    {children}
  </Box>
);
